var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycleanalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.99L7.5 10.48L11.5 14.48L18.59 6.51001L20 7.92001L11.5 17.48L7.5 13.48L1.5 19.49L0 17.99ZM1.5 13.49L7.5 7.48001L11.5 11.48L20 1.92001L18.59 0.51001L11.5 8.48001L7.5 4.48001L0 11.99L1.5 13.49Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleanalytics);
export default __webpack_public_path__ + "static/media/cycleanalytics.7226563fc877afb850b8a0ab7f519f39.svg";
export { ForwardRef as ReactComponent };